import { Stack, Autocomplete, TextField, InputLabel, IconButton, Button, Typography } from "@mui/material";
import { Fragment, useEffect } from "react";
import { v4 as uuidv4 } from 'uuid';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';


import { useState } from "react";
import { FormVariable } from "./FormVariable";
import { useForm } from "../../../hooks/useForm";
import useFetch from "../../../hooks/useFetch";
import { urlProduct } from "../../../helpers";
import { diffDates } from "../../../helpers/productsPrice";

export const FormCertification = ({ data, setProducts, setRents }) => {

    let workData = data[0];
    const { data: dataProduct } = useFetch(urlProduct, 'GET');

    const [inputFields, setInputFields] = useState(JSON.parse(workData.rents));

    const [formValues, handleInputChange] = useForm({
        firstDate: dateFormat(workData.firstDate), lastDate: dateFormat(workData.lastDate)
    })

    const { firstDate, lastDate } = formValues;
    
    const handleChangeInput = (id, event) => {
        const newInputFields = inputFields?.map(i => {
            if (id === i.id) {
                i[event.target.name] = event.target.value
            }
            if (event.target.name === 'firstCertificationDate' || event.target.name === 'lastCertificationDate') {
                i['rentsDays'] = diffDates(i.firstCertificationDate, i.lastCertificationDate)
            }
            return i;
        })
        setInputFields(newInputFields);
        setRents(inputFields)
    }

    const handleAddFields = () => {
        setInputFields([...inputFields, { id: uuidv4(), measure: '', size: '', price: '', concept: '', rentsDays: diffDates(firstDate, lastDate), firstCertificationDate: firstDate, lastCertificationDate: lastDate }])
    }

    const handleRemoveFields = id => {
        const values = [...inputFields];
        values.splice(values.findIndex(value => value.id === id), 1);
        setInputFields(values)
        setRents(values)
    }

    useEffect(() => {
        setRents(inputFields)
    }, [inputFields, setRents])

    useEffect(() => {
        inputFields.forEach((inputField) => {
            handleChangeInput(inputField.id, {target: {
                 name: 'firstCertificationDate', 
                 value: inputField.firstCertificationDate || firstDate
                }
                })
            handleChangeInput(inputField.id, {target: {
                 name: 'lastCertificationDate', 
                 value: inputField.lastCertificationDate || lastDate
                }
                })
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    

    return (
        <Stack width='100%' alignItems='center' spacing={5} sx={{ marginTop: '35px' }}>
            <Stack flexDirection='row' width='95%' flexWrap='wrap' justifyContent='space-between' >
                <InputLabel sx={{ width: '200px' }} >Fecha inicio certificación:</InputLabel >
                <TextField
                    sx={{ width: '200px' }}
                    type="date"
                    variant="standard"
                    name='firstDate'
                    value={firstDate}
                    onChange={handleInputChange}
                    required
                />
                <InputLabel sx={{ width: '200px' }} >Fecha fin certificación: </InputLabel >
                <TextField
                    sx={{ width: '200px' }}
                    type="date"
                    variant="standard"
                    name='lastDate'
                    value={lastDate}
                    onChange={handleInputChange}
                    required
                />
            </Stack>
            {
                inputFields.length > 0
                    ?
                    <>
                        <Typography textAlign='center' variant="subtitle" mb='1rem' color="primary">Alquileres</Typography>
                        {data?.map(a => {
                            return (
                                <Stack flexDirection='row' key='a.id' spacing={1} flexWrap='wrap' justifyContent='space-around' gap={5} width='100%'>
                                    {inputFields?.map(inputField => (
                                        <Fragment key={inputField.id}>
                                            {dataProduct &&
                                                <Autocomplete
                                                    options={dataProduct?.filter(d => d.type === 'Alquiler').map((d) => d.product).concat('') || ['Cargando productos']}
                                                    noOptionsText='Elige una opción correcta'
                                                    fullWidth
                                                    renderInput={(params) => <TextField name='concept'{...params} value={inputField.concept} label="Concepto" required variant="filled" />}
                                                    onSelect={event => handleChangeInput(inputField.id, event)}
                                                    value={dataProduct?.filter(d => d.type === 'Alquiler').map((d) => d.product).concat('').includes(inputField.concept) ? inputField.concept : ''}
                                                />}
                                            <Stack flexDirection='row' gap={2} width='95%' justifyContent='space-around'>
                                                <Stack flexDirection='row' width='95%' flexWrap='wrap' justifyContent='space-between' >
                                                    <InputLabel sx={{ width: '200px' }} >Fecha inicio:</InputLabel >
                                                    <TextField
                                                        sx={{ width: '200px' }}
                                                        type="date"
                                                        variant="standard"
                                                        name='firstCertificationDate'
                                                        value={inputField.firstCertificationDate || firstDate}
                                                        onChange={event => handleChangeInput(inputField.id, event)}
                                                        required
                                                    />
                                                    <InputLabel sx={{ width: '200px' }} >Fecha fin: </InputLabel >
                                                    <TextField
                                                        sx={{ width: '200px' }}
                                                        type="date"
                                                        variant="standard"
                                                        name='lastCertificationDate'
                                                        value={inputField.lastCertificationDate || lastDate}
                                                        onChange={event => handleChangeInput(inputField.id, event)}
                                                        required
                                                    />
                                                </Stack>
                                            </Stack>
                                            {
                                                diffDates(inputField.firstCertificationDate, inputField.lastCertificationDate) < 0 &&
                                                <Typography color='red'>La fecha de fin debe ser superior a la fecha de inicio</Typography>
                                            }
                                            <Stack flexDirection='row' width='95%' justifyContent='space-between' flexWrap='wrap' >
                                                <Autocomplete
                                                    disablePortal
                                                    options={optionsMeasure}
                                                    sx={{ width: 130 }}
                                                    size='small'
                                                    renderInput={(params) => <TextField name='measure'{...params} value={inputField.measure} label="Unidad" required variant="standard" />}
                                                    onSelect={event => handleChangeInput(inputField.id, event)}
                                                    value={optionsMeasure.includes(inputField.measure) ? inputField.measure : ''}
                                                    required
                                                />
                                                <TextField
                                                    sx={{ width: 130 }}
                                                    label="Tamaño"
                                                    type="number"
                                                    variant="standard"
                                                    size='small'
                                                    name='size'
                                                    value={inputField.size}
                                                    onChange={event => handleChangeInput(inputField.id, event)}
                                                    InputProps={{ inputProps: { min: 0 } }}
                                                    required
                                                />
                                                <TextField
                                                    sx={{ width: 130 }}
                                                    label="Precio"
                                                    type="number"
                                                    variant="standard"
                                                    size='small'
                                                    name='price'
                                                    value={inputField.price}
                                                    onChange={event => handleChangeInput(inputField.id, event)}
                                                    InputProps={{ inputProps: { inputMode: "decimal" } }}
                                                    required
                                                />
                                                <IconButton onClick={() => handleRemoveFields(inputField.id)}>
                                                    <DeleteIcon color='primary' />
                                                </IconButton>
                                                <IconButton
                                                    onClick={handleAddFields}
                                                >
                                                    <AddIcon />
                                                </IconButton>
                                            </Stack>
                                        </Fragment>
                                    ))}
                                </Stack>
                            )
                        })}
                    </>
                    :
                    <Button onClick={handleAddFields}>Añadir Alquileres</Button>
            }
            <FormVariable setProducts={setProducts} productList={workData.product} dataProduct={dataProduct} />
        </Stack>
    )
}

const dateFormat = (num) => {
    const day = (num.split('-')[2].length === 1) ? '0' + num.split('-')[2] : num.split('-')[2];
    const month = (num.split('-')[1].length === 1) ? '0' + num.split('-')[1] : num.split('-')[1];
    return num.split('-')[0] + '-' + month + '-' + day
}

const optionsMeasure = ['m2', 'ud', 'm3', ''];